import React, {ReactElement} from 'react';
import {Card, CardContent} from '@material-ui/core';
import {ErrorOutlined as LinkDisconnectedIcon} from '@material-ui/icons';

interface ErrorCardProps {
  message: string | ReactElement;
}

const ErrorCard = (props: ErrorCardProps): ReactElement => {
  const {message} = props;
  // FIXME: Do class level changes instead of inline styling
  return (
    <Card>
      <CardContent
        style={{display: 'flex', flexDirection: 'row', padding: '12px 8px'}}>
        <LinkDisconnectedIcon color={'error'} />
        <span
          style={{
            margin: '0.2rem 0 0 0.2rem',
            display: 'flex',
            alignItems: 'center'
          }}>
          {message}
        </span>
      </CardContent>
    </Card>
  );
};
export default ErrorCard;
